import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const ORDERSTATUSFOLLOWORDERCARDBLOCK_LEGACY_FIELD_ORDER = [
  "text",
  "linkText",
  { type: 'separator' },
  "display_only_if_payment_methods",
  "enabled_for_payment_methods",
  { type: 'separator' },
  "display_only_if_types",
  "enabled_for_types",
  { type: 'heading', value: "Couleurs" },
  "text_color",
  "background_color"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  orderStatusFollowOrderCardBlockDescriptor: _generatedOrderStatusFollowOrderCardBlockDescriptor,
  orderStatusFollowOrderCardBlockBlocDefinition,
  orderStatusFollowOrderCardBlockDashboardLayout,
  orderStatusFollowOrderCardBlockConfig,
  orderStatusFollowOrderCardBlockResolveConfig,
  orderStatusFollowOrderCardBlockProperties,
} = doodBlockConfig(
  {
    name: "Follow order card",
    componentType: 'OrderStatusFollowOrderCardBlockComponent',
    category: 'content',
    description: "Follow order card.",
    keywords: [],
    allowedIn: [
      { bloc: 'OrderStatusPageComponent', slot: '*' },
    ],


    sharedFields: {}
  },

  () => ({
    text: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.order-status-follow-order-card.text.label",
        help: "pages.blocks.order-status-follow-order-card.text.help",
      }
    }),
    linkText: propertyValue({
      type: 'link',
      value: '',
      options: {
        label: "pages.blocks.order-status-follow-order-card.link-text.label",
        help: "pages.blocks.order-status-follow-order-card.link-text.help",
      }
    }),
    display_only_if_payment_methods: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.order-status-follow-order-card.display-only-if-payment-methods.label",
      }
    }),
    enabled_for_payment_methods: propertyValue({
      type: 'select',
      value: "",
      options: {
        label: "pages.blocks.order-status-follow-order-card.enabled-for-payment-methods.label",
        multiple: true,
        choices: [
          {
            value: "ON_SITE_WITHOUT_DEPOSIT",
            label: "pages.blocks.order-status-follow-order-card.enabled-for-payment-methods.options.ON_SITE_WITHOUT_DEPOSIT",
          },
          {
            value: "HOUSE_ACCOUNT",
            label: "pages.blocks.order-status-follow-order-card.enabled-for-payment-methods.options.HOUSE_ACCOUNT",
          },
          {
            value: "ONSITE",
            label: "pages.blocks.order-status-follow-order-card.enabled-for-payment-methods.options.ONSITE",
          }
        ]
      }
    }),
    display_only_if_types: propertyValue({
      type: 'checkbox',
      value: false,
      options: {
        label: "pages.blocks.order-status-follow-order-card.display-only-if-types.label",
      }
    }),
    enabled_for_types: propertyValue({
      type: 'select',
      value: "",
      options: {
        label: "pages.blocks.order-status-follow-order-card.enabled-for-types.label",
        multiple: true,
        choices: [
          {
            value: "click-and-collect",
            label: "pages.blocks.order-status-follow-order-card.enabled-for-types.options.click-and-collect",
          },
          {
            value: "delivery",
            label: "pages.blocks.order-status-follow-order-card.enabled-for-types.options.delivery",
          },
          {
            value: "on-site",
            label: "pages.blocks.order-status-follow-order-card.enabled-for-types.options.on-site",
          },
          {
            value: "shipping",
            label: "pages.blocks.order-status-follow-order-card.enabled-for-types.options.shipping",
          },
          {
            value: "eat-in",
            label: "pages.blocks.order-status-follow-order-card.enabled-for-types.options.eat-in",
          }
        ]
      }
    }),
    text_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-800"},
      options: {
        label: "pages.blocks.order-status-follow-order-card.text-color.label",
      }
    }),
    background_color: propertyValue({
      type: 'color',
      value: {"type":"palette","value":"neutral-100"},
      options: {
        label: "pages.blocks.order-status-follow-order-card.background-color.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.order-status-follow-order-card.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.order-status-follow-order-card.fieldset.message.label",
            fields: ["text", "linkText", "text_color", "background_color"],
          },
          {
            legend: "pages.blocks.order-status-follow-order-card.fieldset.payment-methods.label",
            fields: [
              "display_only_if_payment_methods",
              {
                prop: "enabled_for_payment_methods",
                visibleWhen: { display_only_if_payment_methods: true },
              },
            ],
          },
          {
            legend: "pages.blocks.order-status-follow-order-card.fieldset.order-types.label",
            fields: [
              "display_only_if_types",
              {
                prop: "enabled_for_types",
                visibleWhen: { display_only_if_types: true },
              },
            ],
          },
        ],
      },
    ],
  })
);

export function orderStatusFollowOrderCardBlockDescriptor(): IBlockDescriptor;
export function orderStatusFollowOrderCardBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function orderStatusFollowOrderCardBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedOrderStatusFollowOrderCardBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedOrderStatusFollowOrderCardBlockDescriptor, orderStatusFollowOrderCardBlockProperties, fieldOrder);
}

export {
  orderStatusFollowOrderCardBlockBlocDefinition,
  orderStatusFollowOrderCardBlockDashboardLayout,
  orderStatusFollowOrderCardBlockProperties,
  orderStatusFollowOrderCardBlockConfig,
  orderStatusFollowOrderCardBlockResolveConfig,
};

export type OrderStatusFollowOrderCardBlockConfig = typeof orderStatusFollowOrderCardBlockConfig;
